import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getClientSideMyLatestSubscriptionStatus } from '@chegg/commerce-utils';
import { useState } from 'react';
import { TeamInfo } from '@chegg/observability';
import { useEffect } from 'react';
import { initApolloClient } from '../apollo/client';
var getSubscriptionDetails = function getSubscriptionDetails(subscription) {
  var status = subscription ? subscription.myLatestSubscriptionStatus : null;
  return {
    status: status
  };
};
export var useGetSubscriptionDetails = function useGetSubscriptionDetails(environment) {
  var _data$myLatestSubscri;
  var client = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : initApolloClient();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState({
      myLatestSubscriptionsV1: null
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    data = _useState6[0],
    setData = _useState6[1];
  useEffect(function () {
    getClientSideMyLatestSubscriptionStatus({
      apolloClient: client,
      teamName: TeamInfo['FT-Rigel'].name,
      environment: environment
    }).then(function (data) {
      setData(data.data);
    })["catch"](function (error) {
      setError(error);
    })["finally"](function () {
      setLoading(false);
    });
  }, []);
  var cheggWritingSubscription = (_data$myLatestSubscri = data.myLatestSubscriptionsV1) === null || _data$myLatestSubscri === void 0 ? void 0 : _data$myLatestSubscri.cheggWriting;
  var subscriptionDetails = cheggWritingSubscription ? getSubscriptionDetails(cheggWritingSubscription) : undefined;
  return {
    error: error,
    loading: loading,
    data: subscriptionDetails
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/hooks/useGetSubscriptionDetails.js
// module id = 5222
// module chunks = 11